import script from "./Powerbi.vue?vue&type=script&setup=true&lang=js"
export * from "./Powerbi.vue?vue&type=script&setup=true&lang=js"

import "./Powerbi.vue?vue&type=style&index=0&id=63de7b00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63de7b00"]])

export default __exports__